// extracted by mini-css-extract-plugin
export default {"page":"not_found_page__4NIDa"};